import React from 'react';
import './index.css';
import { Switch, Route } from 'react-router-dom';
import CustomSnackbar from './Common/CustomSnackbar';
import SchedulerHome from './Components/SchedulerHome';

function App() {
  return (
    <div id="app-root">
      <Switch>
        <Route path="/" component={SchedulerHome}  />
      </Switch>
      <CustomSnackbar></CustomSnackbar>
    </div>
  )
}

export default App;
